import React from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import useInputChange from "../../../utils/hooks/useInputChange";
import { useLocation } from "react-router-dom";
import { isEmptyObject } from "../../../utils/validators/validators";
import { setApplicationInfo } from "../../../redux/slice/customer/customerSlice";
import { useEffect } from "react";
import Form from "../../form/Form";

const BusinessInformation = ({ contactInfoRef }) => {
  const { application_info } = useSelector((state) => state.customer);
  const [userInput, setUserInput] = useState({
    occupation: "",
    business_address: "",
  });
  const [error, setError] = useState({});
  const [input, handleChange] = useInputChange(
    application_info,
    setUserInput,
    error,
    setError
  );

  const dispatch = useDispatch();
  const location = useLocation();

  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      contactInfoRef.current.click();
    }
  };

  useEffect(() => {
    dispatch(setApplicationInfo(userInput));
  }, [userInput]);

  return (
    <div className='border border-top-0 px-3 py-3'>
      <Form setError={setError} submitHandler={handleSubmit} values={userInput}>
        <div className='row mb-2'>
          <div className='mb-0 mt-3 col-md-12'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Occupation</span>
              <span className='text-danger'>*</span>
            </label>
            <input
              textname='occupation'
              name='occupation'
              onChange={handleChange}
              value={input.occupation}
              type='text'
              id='occupation'
              className={`form-control ${error.occupation && "is-invalid"}`}
              placeholder='Enter Occupation'
            />
            {error.occupation && (
              <span className='invalid-feedback'>{error.occupation}</span>
            )}
          </div>

          <div className='mb-0 mt-3 col-md-12'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Business Address </span>
              <span className='text-danger'>*</span>
            </label>
            <textarea
              rows={4}
              textname='residential address'
              name='business_address'
              onChange={handleChange}
              value={input.business_address}
              className={`form-control ${
                error.business_address && "is-invalid"
              }`}
            ></textarea>
            {error.business_address && (
              <span className='invalid-feedback'>{error.business_address}</span>
            )}
          </div>
        </div>
        <div className='d-flex justify-content-end mb-3 mt-2'>
          <button type='submit' className='btn btn-primary'>
            Proceed
          </button>
        </div>
      </Form>
    </div>
  );
};

export default BusinessInformation;
